// Pure helper: extract a Drive folder id from common URL variants.
// Returns null on parse failure so the caller can render an inline hint
// rather than throwing.
//
// Recognised shapes:
//   https://drive.google.com/drive/folders/<ID>
//   https://drive.google.com/drive/folders/<ID>?usp=sharing
//   https://drive.google.com/drive/folders/<ID>/
//   https://drive.google.com/drive/u/0/folders/<ID>
//   https://drive.google.com/open?id=<ID>
//   https://drive.google.com/drive/u/0/folders/<ID>?pli=1
//
// We also accept a bare folder id (the regex already validates the shape).
// Drive ids are alphanumeric plus `-` and `_`; minimum length is generous
// at 10 characters so a stray short fragment doesn't pass.

const FOLDER_PATH_RE = /\/folders\/([A-Za-z0-9_-]{10,})/;
const OPEN_QUERY_RE = /[?&]id=([A-Za-z0-9_-]{10,})/;
const BARE_ID_RE = /^[A-Za-z0-9_-]{10,}$/;

export function parseDriveFolderUrl(input: string | null | undefined): string | null {
  if (typeof input !== 'string') return null;
  const trimmed = input.trim();
  if (!trimmed) return null;

  if (BARE_ID_RE.test(trimmed)) return trimmed;

  const pathMatch = trimmed.match(FOLDER_PATH_RE);
  if (pathMatch && pathMatch[1]) return pathMatch[1];

  const queryMatch = trimmed.match(OPEN_QUERY_RE);
  if (queryMatch && queryMatch[1]) return queryMatch[1];

  return null;
}
